<template>
<div class="vliveExampleWechatShare">
    <div class="phone-model phone_model">
        <div class="vlive-wechat-share">
            <div class="box">
                <div class="title blod">{{vliveModel.weChatShare.sharesubject}}</div>
                <div class="summary">
                    <div class="content text-ellipse">{{vliveModel.weChatShare.sharedesc}}</div>
                    <img :src="vliveModel.weChatShare.coverPicture.furl +'?'+vliveModel.weChatShare.coverPicture.fsize" alt="" v-if="vliveModel.weChatShare.coverPicture">
                </div>
            </div>
            <div><img :src="user.logourl" alt="" class="logo"></div>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'vliveExample',
    data() {
        return {
            activeName: 'imageText'
        }
    },
    created() {
    },
    mounted() {},
    methods: {
        handleClick() {

        },
        ...mapActions([
            'setVliveModel'
        ])
    },
    filters: {},
    watch: {
        vliveModel: {
            handler: function() {
                $('.vlive-nav .el-tabs__item.is-active').css({color: this.vliveModel.contentthemecolor})
                $('.vlive-nav .el-tabs__active-bar').css({backgroundColor: this.vliveModel.contentthemecolor})
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'vliveModel',
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveExampleWechatShare {
    .phone-model{
        .vlive-wechat-share{
            margin: 20px 10px;
            @include flexBox(flex-end);
            .logo{
                width: 36px;
                height: 36px;
                margin-left: 10px;
            }
            .box{
                box-sizing: border-box;
                padding: 10px;
                border: 1px dashed $line;
                height: 100px;
                max-width: 200px;
                min-width: 150px;
                overflow: hidden;
                .title{
                    font-size: $font-14;
                    margin-bottom: 10px;
                }
                .summary{
                    @include flexBox(space-between);
                    .content{
                        height: 42px;
                        line-height: 14px;
                        max-width: 120px;
                        font-size: 12px;
                        color: $tcolor-gray;
                    }
                    img{
                        width: 42px;
                        height: 42px;
                        margin-left: 10px;
                    }
                }
            }
        }
    }
}
</style>
